import React, { Component } from 'react';
import Constants from '../../Config/Config';
import {roundToTwo} from '../../Helpers/Helpers';

class Shipping extends Component {

	constructor(props) {
        super(props);
        this.state = {
			qtyError: false
        }
    }

	onChange = (e) => {
		var qValue = e.target.value;
		if (qValue !== '') {
			qValue = Math.ceil(qValue);
			if (parseFloat(qValue) <= 0)
				qValue = 1;
		}
		if (parseFloat(qValue) > Constants.MAX_QTY) {
			this.setState({ qtyError: true })
		} else {
			this.props.dispatch({
	            type: 'SET_STATE',
	            state: {
	                qty: qValue
	            }
	        });
	        this.setState({ qtyError: false })
		}
	}

	getCartTotal = () =>  {
		const {frameTotal, glassTotal, backingTotal, printTotal, topMatTotal, middleMatTotal, bottomMatTotal, selectedMatSize} = this.props;
		let topMat = topMatTotal;
		let middleMat = middleMatTotal;
		let bottomMat = bottomMatTotal;

		if ( parseFloat(selectedMatSize) === 0) {
			topMat = 0;
			middleMat = 0;
			bottomMat = 0;
		}

		if ( parseFloat(selectedMatSize) === 1 ) {
			middleMat = 0;
			bottomMat = 0;
		}

		if ( parseFloat(selectedMatSize) === 2 ) {
			bottomMat = 0;
		}

		var output = parseFloat(frameTotal) + parseFloat(glassTotal) + parseFloat(backingTotal || 0) + parseFloat(printTotal) + parseFloat(topMat) + parseFloat(middleMat) + parseFloat(bottomMat);

	    this.props.dispatch({
			type: 'SET_STATE',
			state: {
				cart1ItemTotal: output.toFixed(2)
			}
		})
	}

	componentDidUpdate(prevProps, prevState) {
	    if (prevProps.frameTotal !== this.props.frameTotal || prevProps.qty !== this.props.qty || prevProps.glassTotal !== this.props.glassTotal || prevProps.backingTotal !== this.props.backingTotal || prevProps.printTotal !== this.props.printTotal || prevProps.topMatTotal !== this.props.topMatTotal || prevProps.middleMatTotal !== this.props.middleMatTotal || prevProps.bottomMatTotal !== this.props.bottomMatTotal || prevProps.selectedMatSize !== this.props.selectedMatSize) {
	      	this.getCartTotal();
	  	}
	}

  	render() {
  		const {qty, cart1ItemTotal} = this.props;
	    return (
	    	<div>
		        <div className="cont_rgt_qty">
					<ul>
						<li>
							<label>Quantity:</label>
							<div className="quantity">
								<input type="number" name="qty" value={qty} onChange={this.onChange} className={this.props.qty === '' ? "image-size-error" : ""} />
							</div>
						</li>
						<li className="cart-total">
							<p>Total: <span>{Constants.Currency + roundToTwo(cart1ItemTotal * qty)}</span></p>
						</li>
					</ul>
				</div>
				{this.state.qtyError &&
					<div className="alert alert-info m-b-5">
						Max allowed quantity is {Constants.MAX_QTY}. Please email us to obtain a quote for greater quantity.
					</div>
				}
			</div>
	    );
  	}
}

export default Shipping;